import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from 'semantic-ui-react';

import { CurrencyEuroCircle, LockCircle, TimeClockCircle } from '../../icons';

const icons = (icon) => {
  switch (icon) {
    case 'CurrencyEuroCircle':
      return <CurrencyEuroCircle />;
    case 'LockCircle':
      return <LockCircle />;
    case 'TimeClockCircle':
      return <TimeClockCircle />;
    default:
      return null;
  }
};

const ValueItem = ({ icon, title, description }) => (
  <div className="value-item">
    <Grid columns={2}>
      <Grid.Row>
        <Grid.Column width={3}>
          <div className="icon-wrapper">
            {icons(icon)}
          </div>
        </Grid.Column>

        <Grid.Column width={13}>
          <h3 className="title">{title}</h3>

          <p className="text text-muted">{description}</p>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

ValueItem.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ValueItem;
